import { render } from "./ResetPasswordView.vue?vue&type=template&id=ce6ccd3e&scoped=true&ts=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=ce6ccd3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6ccd3e"]])

export default __exports__